import React from 'react';
import { useTranslation } from 'react-i18next';
import TweenOne from 'rc-tween-one';
import { Row, Col } from 'antd';
import QueueAnim from 'rc-queue-anim';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '@/utils';

function Content7(props) {
  const { dataSource, isMobile, ...restProps } = props;
  const { t } = useTranslation();

  const getBlockChildren = (data) =>
    data.map(($item) => {
      const { ...item } = $item;
      const { title, content } = item;
      ['title', 'img', 'content'].forEach((key) => delete item[key]);
      return (
        <li key={item.name} {...item}>
          <h2 {...title}>{t(title.children)}</h2>
          <div {...content}>{t(content.children)}</div>
        </li>
      );
    });
  const ulChildren = getBlockChildren(dataSource.block.children);
  const queue = isMobile ? 'bottom' : 'left';
  const imgAnim = isMobile
    ? {
      y: 30,
      opacity: 0,
      delay: 600,
      type: 'from',
      ease: 'easeOutQuad',
    }
    : {
      x: 30,
      opacity: 0,
      type: 'from',
      ease: 'easeOutQuad',
    };

  const childrenItem = dataSource.block.measure.map(($item, i) => {
    const { number, children: child, ...childProps } = $item;
    const numberChild = number.children.replace(/[^0-9.-]/g, '');
    const { unit, ...numberProps } = number;
    return (
      <Col {...childProps} key={i.toString()}>
        <TweenOne
          {...numberProps}
          animation={{
            Children: {
              value: parseFloat(numberChild),
              floatLength:
                parseFloat(numberChild) -
                Math.floor(parseFloat(numberChild)) >
                0
                  ? 2
                  : 0,
              formatMoney: false,
            },
            duration: 1000,
            delay: 300,
            ease: 'easeInOutCirc',
          }}
          component="span"
        >
          0
        </TweenOne>
        {unit && <span {...unit}>{t(unit.children)}</span>}
        <p {...child}>{t(child.children)}</p>
      </Col>
    );
  });

  return (
    <div {...restProps} {...dataSource.wrapper}>
      <OverPack {...dataSource.OverPack} component={Row}>
        <QueueAnim
          key="text"
          type={queue}
          leaveReverse
          ease={['easeOutQuad', 'easeInQuad']}
          {...dataSource.textWrapper}
          component={Col}
        >
          <div key="title" {...dataSource.titleWrapper}>
            {dataSource.titleWrapper.children.map((item, index) => getChildrenToRender(item, index, t))}
          </div>
          <QueueAnim
            component="ul"
            key="ul"
            type={queue}
            ease="easeOutQuad"
            {...dataSource.block}
          >
            {ulChildren}
          </QueueAnim>
          <QueueAnim type="bottom" component={Row}>
            {childrenItem}
          </QueueAnim>
        </QueueAnim>

        {/* rigth */}
        <TweenOne
          key="img"
          animation={imgAnim}
          resetStyle
          {...dataSource.img}
          component={Col}
        >
          <img src={dataSource.img.children} width="100%" alt="img" />
        </TweenOne>
      </OverPack>
    </div>
  );
}

export default Content7;
